module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "half-title"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Mrs. Adams in Winter")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0002-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "fig03"
    }
  }), _vm._v("Charles Robert Leslie, "), _c('em', [_vm._v("Louisa Catherine Adams")]), _vm._v(" (1816);"), _c('br'), _vm._v("engraving by G. F. Storm (ca. 1839)"), _c('br'), _vm._v(" (Courtesy of Private Collection/The Stapleton Collection/The Bridgeman Art Library)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e992cf78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/halftitle01.vue
// module id = 81
// module chunks = 0